/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { getAbout, updateAbout } from "actions/about";
import { clearAbout } from "features/aboutSlice";
import { AboutUsContentForm, ComponentHeader } from "components";
import { ADMIN_TEXTS } from "constants/adminTexts";
import { FILE_TYPE } from "constants/fileTypes";
import "./About.scss";

const T = ADMIN_TEXTS.about;
const imageBase = process.env.REACT_APP_API_IMAGE_URL;

export const AboutContent = () => {
  const dispatch = useDispatch();
  const { about, loading, updateLoading } = useSelector((state) => state.about);

  const getInitialValues = () => {
    if (!about) return {};
    return {
      title: about.title || "",
      description: about.description || "",
      media1Url: about.media1 ? `${imageBase}${about.media1.path}` : null,
      media1IsVideo: about.media1?.type === FILE_TYPE.VIDEO,
      media2Url: about.media2 ? `${imageBase}${about.media2.path}` : null,
      media2IsVideo: about.media2?.type === FILE_TYPE.VIDEO,
    };
  };

  const handleSubmit = ({ title, description, media1File, media2File }) => {
    dispatch(
      updateAbout({ data: { title, description }, media1File, media2File }),
    );
  };

  useEffect(() => {
    dispatch(getAbout());
    return () => {
      dispatch(clearAbout());
    };
  }, []);

  if (loading) {
    return (
      <Box className="loading-container">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className="about-content">
      <ComponentHeader title={T.aboutContent} />
      <AboutUsContentForm
        initialValues={getInitialValues()}
        onSubmit={handleSubmit}
        loading={updateLoading}
      />
    </Box>
  );
};
